import { getToken } from "./getToken";

export const isAuthenticated = () => {
  const token = getToken();
  return typeof token === "string" && token.length > 0;
};
